export default __webpack_public_path__ + "static/media/downloadPdfNew.b3542253.svg";